/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
export function assignedElements(slot: HTMLSlotElement): Element[] {
  const rootNode = slot.getRootNode();
  return rootNode instanceof ShadowRoot
    ? Array.from(rootNode.host.children).filter((child) => child.slot === slot.name)
    : [];
}
